import axios from "axios";

import { getErrorResponseMessage } from '../utils/functions/response';
import { RESPONSE_HEADER } from "../utils/enums";

export const fetchHinweise = (axiosObject) => async dispatch => {
  try {
    const response = await axios[axiosObject.request.type](axiosObject.url, axiosObject.json, axiosObject.request.config);
    if (
      response &&
      response.data &&
      response.data.header &&
      response.data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL
    ) {
            
      if (response.data && response.data.hinweise) {
        if (Array.isArray(response.data.hinweise)) {
          dispatch(setHinweise(response.data.hinweise));
        }
      }              
    } else if (
      response &&
      response.status < 400 &&
      !response.data
    ) {
      dispatch({
        type: 'SET_HINWEISE',
      });
    } else {
      const message = getErrorResponseMessage(response) || "e2: Ein Übertragungsfehler ist aufgetreten";
      throw new Error(message);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export function setHinweise(hinweise) {
  return {
    type: 'SET_HINWEISE',
    payload: hinweise
  };
}

export const storeHinweise = (axiosObject, requestData) => async dispatch => {
  if (axiosObject && !requestData && axiosObject.json) {
    requestData = axiosObject.json;
  }
  await axios[axiosObject.request.type](axiosObject.url, requestData)
    .catch(err => {
      console.error("store hinweise", err);      
      throw err;
  });
};
